import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
      <section className='intro'>
          <h1>Hello. I’m Michael.</h1>
           <p>I am a full time Web Designer&#x2f;Front-End developer living in the beautiful state of <a href={"https://youtu.be/VGF4ibgcHQE?t=7s"}>Texas</a>.</p>
           <p>When I am not dumping random notes, pictures or code snippets here, you can normally find me with a cup of coffee <em>(hot or iced, doesn’t matter to me)</em> and a comic book.</p>
       </section>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js